module.exports = __webpack_public_path__ + "media/images/icons/filled/like-34c54e5c6f5394fa92dbc4fa0f18bb38.svg";